import Base from './Base';

class Auth extends Base {

    constructor () {
        super();
        this.endpoint = 'auth';
    }

    login(userData){
        return  fetch(this.getUrlEndpoint("login"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(userData)
        }).then( response => response.json() )
    }

    hashogin(hashogin){
        return  fetch(this.getUrlEndpoint("hashogin"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(hashogin)
        }).then( response => response.json() )
    }

    requestRecoverPassword(email){
        return  fetch(this.getUrlEndpoint("request-password-recover"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(email)
        }).then( response => response.json() )
    }
    
    checkValidRecoverPassword(hashrecovery){
        return  fetch(this.getUrlEndpoint("check-valid-recover"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(hashrecovery)
        }).then( response => response.json() )
    }

    changePassword(data){
        return  fetch(this.getUrlEndpoint("change-password"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    signup(userData){
        return  fetch(this.getUrlEndpoint("signup"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(userData),
            mode: 'cors',
        }).then( response => {
            console.log("SIGNUP",response)    
            return response.json() 
        }
        )
    }

    validateSession(id,token){
        return  fetch(this.getUrlEndpoint("validate-session/"+id+'/'+token),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default Auth;